<template>
    <div>
        <p class="timeline-talks">{{ message }}</p>
    </div>
</template>

<script>
export default {
    /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
    props: ['details'],
    /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */
    data() {
        return {}
    },
    /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
    computed: {
        message() {
            return 'Trigger alert has been created on Delta Upload and auto rejected because of risk override'
        },
    },
}
</script>
